module.exports = __webpack_public_path__ + "img/2.6a161c30.png";